/*******************************************************************************
* @ngdoc       provider
* @name        ReceiptsServiceProvider
* @module      csm.books.WriteReceipts
* @description 
* Provides configuration of the ReceiptsService.
*******************************************************************************/
/* @ngInject */ export function ReceiptsServiceProvider($injector) {
  this.httpServiceBase = '/books/receipts/';
  this.httpServices = {
    dropReceipt: function (id) {
      return this.get('dropReceipt/{0}'.format(id));
    },
    getProductList: function () {
      return this.get('getProductList');
    },
    getReceipt: function (id, dir) {
      return this.get('getReceipt/{0}/{1}'.format(id || 0, dir || 0));
    },
    getReceiptFundraisersAndAccounts: function () {
      return this.post('getReceiptFundraisersAndAccounts');
    },
    getReceiptScreenInfo: function () {
      return this.get('getReceiptScreenInfo');
    },
    getStudentBalanceAndIndicators: function (entityID) {
      return this.get(
        'getStudentBalanceAndIndicators/{0}'.format(entityID)
      );
    },
    saveReceipt: function (data) {
      return this.post('saveReceipt', data);
    },
    viewReceivables: function (entityID, receiptID) {
      return this.post('viewReceivables', {
        entityID: entityID,
        receiptID: receiptID
      });
    },
    voidReceipt: function (data) {
      return this.post('voidReceipt', data);
    }
  };

  /**
   * @ngdoc       service
   * @name        ReceiptsService
   * @module      csm.books.WriteReceipts
   * @description Receipts controller services.
   */
  this.$get = ['HTTPService', function (HTTPService) {
    return Object.assign(
      HTTPService.make(this.httpServiceBase),
      this.httpServices
    );
  }];
};
